<script setup lang="ts">
import { Icon } from '@collector/shared-ui'

import { ListItemStatusProps } from '../../interfaces/ListItemStatusProps'

defineProps<ListItemStatusProps>()
</script>

<template>
  <div class="w-20 items-center font-bold">
    <div class="text-2xs text-default/60">Status:</div>
    <div
      class="text-xs"
      :class="{
        'text-error-7': status === 'Error',
      }"
    >
      <Icon
        class="w-2"
        :icon="status === 'Error' ? 'exclamation' : 'stopwatch'"
      />
      {{ status }}
    </div>
  </div>
</template>
